module.exports = __webpack_public_path__ + "static/media/moon.e0fa522c.svg";